import { memo, useContext } from 'react';
import { PayoutSummary } from '../../tournaments/heats-leaderboards/PayoutSummary';
import { TournamentContext } from '../../../contexts/docs/TournamentContext';
import { GradientTypographyProps } from '../../gradients/GradientTypography';
import { useCurrency } from '../../../contexts/CurrencyContext';

export type TournamentPayoutProps = Omit<
  GradientTypographyProps,
  'gradientColor'
>;

const TournamentPayoutUnmemoized = (props: TournamentPayoutProps) => {
  const { payouts, payoutGiveaway } = useContext(TournamentContext);
  const { formatTotalPayout, formatPayout } = useCurrency();
  const totalPayout = formatTotalPayout(payouts);
  const giveawayPayout = formatPayout(payoutGiveaway);
  const { amountFiat: payoutAmount, countItems: payoutItems } = totalPayout;
  const { amountFiat: giveAwayAmount, countItems: giveAwayItems } =
    giveawayPayout;
  const amountFiat = payoutAmount + giveAwayAmount;
  const countItems = payoutItems + giveAwayItems;

  return (
    <PayoutSummary amountFiat={amountFiat} countItems={countItems} {...props} />
  );
};

export const TournamentPayout = memo(TournamentPayoutUnmemoized);
